/* bootstrap for static content pages: about, contact, faq, guides index */
import { mountChrome } from './chrome.js?v=1789681238';
import { initMotion } from './motion.js?v=1789571604';

mountChrome();

/* Inline, non-destructive validation feedback shared by the site's forms. */
function clearFieldErrors(form) {
  form.querySelectorAll('.field-error').forEach(n => n.remove());
  form.querySelectorAll('[aria-invalid]').forEach(f => {
    f.removeAttribute('aria-invalid');
    f.removeAttribute('aria-describedby');
  });
}

function showFieldErrors(form, bad) {
  clearFieldErrors(form);
  bad.forEach((f, i) => {
    f.setAttribute('aria-invalid', 'true');
    const id = `err-${f.name || f.id || i}`;
    f.setAttribute('aria-describedby', id);
    const msg = document.createElement('p');
    msg.className = 'field-error';
    msg.id = id;
    msg.textContent = f.validity.valueMissing
      ? 'This field is required.'
      : (f.validationMessage || 'Please check this field.');
    (f.closest('.field') || f.parentElement).appendChild(msg);
  });
  bad[0].focus();
}

/* On the storefront, chrome.js has rewired this form to post to Shopify, so we
   must not intercept it. This branch only runs on the local static build, where
   there is no endpoint - say that plainly rather than faking a delivery. */
document.addEventListener('submit', e => {
  if (!e.target.matches('.contact-form')) return;
  if (e.target.dataset.native === '1') return;
  e.preventDefault();
  const form = e.target;
  const fields = [...form.querySelectorAll('[required]')];
  const bad = fields.filter(f => !f.checkValidity());
  if (bad.length) {
    /* Replacing form.innerHTML on a FAILED validation destroyed the very inputs the
       visitor needs to correct, with no way back short of reloading the page. Mark the
       fields instead and leave everything typed exactly where it is. */
    showFieldErrors(form, bad);
    return;
  }
  clearFieldErrors(form);
  form.innerHTML = '<p class="lede">This is the local preview build, so nothing was sent. On the live store this reaches the team inbox. Email <a href="mailto:hello@lepetitskincare.com">hello@lepetitskincare.com</a> in the meantime.</p>';
});

/* FAQ accordion - same open/close pattern as the PDP accordion in product.js */
document.addEventListener('click', e => {
  const trigger = e.target.closest('.accordion-trigger');
  if (!trigger) return;
  const item = trigger.closest('.accordion-item');
  item.classList.toggle('is-open');
  trigger.setAttribute('aria-expanded', String(item.classList.contains('is-open')));
});

initMotion();
